import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.NaZgJh',
    defaultMessage: 'Something went wrong when fetching all blocks.',
  },
});
